/** @format */
import attainedCreditsTpl from './attainedCredits.tpl.html';
'use strict';
(function () {
  angular.module('student.timing.attainedCredits', ['pascalprecht.translate', 'sis-common.l10n.localizedStringFilter']).component('attainedCredits', {
    bindings: {
      credits: '<'
    },
    template: attainedCreditsTpl
  });
})();